import React from 'react';
import PageShell from '../../components/PageShell';
import { SectionHeading, GradientButton, CTABanner } from '../../components/common/Primitives';
import ModuleCard from '../../components/common/ModuleCard';
import LicenceFeeHighlight from '../../components/common/LicenceFeeHighlight';
import GyanMitraSection from '../../components/common/GyanMitraSection';
import { SCHOOL_EXPERIENCES } from '../../lib/mockSchool';
import { PlayCircle } from 'lucide-react';

export default function SchoolExperiences() {
  const d = SCHOOL_EXPERIENCES;
  return (
    <PageShell>
      {/* HERO */}
      <section className="px-6 pt-12 pb-6" data-testid="school-experiences-hero">
        <div className="mx-auto max-w-[1240px]">
          <h1 className="text-[36px] md:text-[48px] font-extrabold leading-[1.05] tracking-tight text-navy">{d.hero.title}</h1>
          <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-ink-500">{d.hero.desc}</p>
          <div className="mt-6"><LicenceFeeHighlight /></div>
        </div>
      </section>

      {/* CURRICULUM MODULES */}
      <section className="px-6 py-14">
        <div className="mx-auto max-w-[1240px]">
          <SectionHeading eyebrow={d.curriculum.eyebrow} title={d.curriculum.title} desc={d.curriculum.desc} />
          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {d.curriculum.items.map((m, i) => (
              <ModuleCard key={i} subject={m.subject} status={m.status} title={m.title} desc={m.chapter} duration="35–45 min" lang="EN / HI / AS" />
            ))}
          </div>
        </div>
      </section>

      {/* EXPLORATION */}
      <section className="px-6 py-14 bg-white">
        <div className="mx-auto max-w-[1240px]">
          <SectionHeading eyebrow={d.exploration.eyebrow} title={d.exploration.title} desc={d.exploration.desc} />
          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {d.exploration.items.map((m, i) => (
              <ModuleCard key={i} subject={m.subject} status={m.status} title={m.title} desc={m.chapter} duration="35–45 min" lang="EN / HI / AS" />
            ))}
          </div>
        </div>
      </section>

      <GyanMitraSection />

      {/* CTA */}
      <section className="px-6 pb-24">
        <div className="mx-auto max-w-[1240px]">
          <CTABanner
            title={d.cta.title}
            desc={d.cta.desc}
            primary={d.cta.primary}
            secondary={d.cta.secondary}
          />
        </div>
      </section>
    </PageShell>
  );
}
